export default "__VITE_ASSET__73ae1bd9__"